import 'regenerator-runtime/runtime'
import './errors'
import {initializeCellAccessibility} from './cell-accessibility'
import {highlight} from './highlight'
import sanitizeNotebook from './html-sanitizer'
import iframeMessenger, {initDefaultListeners} from './iframe-messenger'
import {logger} from './logger'

const Logger = logger('initializer')

async function typeset(code) {
  window.MathJax.startup.promise = window.MathJax.startup.promise
    // eslint-disable-next-line github/no-then
    .then(async () => {
      window.MathJax.typesetPromise(await code())
    })
    // eslint-disable-next-line github/no-then
    .catch(err => Logger.error(`Typeset failed`, err.message))
  return window.MathJax.startup.promise
}

// Establish iframe communication layer
iframeMessenger.init()
initDefaultListeners()

document.addEventListener('DOMContentLoaded', async () => {
  const errorPage = document.getElementsByClassName('error-block')[0]
  if (errorPage) return
  const sanitizedDoc = await sanitizeNotebook()
  const notebookContainer = document.getElementById('notebook-container')

  if (!notebookContainer) {
    iframeMessenger.post('error', {message: 'Invalid DOM'})
    return
  }

  initializeCellAccessibility(notebookContainer)

  try {
    typeset(async () => {
      await highlight({content: sanitizedDoc})
      notebookContainer.appendChild(sanitizedDoc)

      return [notebookContainer]
    })
  } catch (e) {
    iframeMessenger.post('error', {message: e.message})
  }
})
